module.exports = __webpack_public_path__ + "static/media/chape-holder.d6cc46c4.png";